import { Link } from 'react-router-dom';

const FRIEND_LINKS = [
  { label: '豆瓣电影', href: 'https://movie.douban.com' },
  { label: '猫眼电影', href: 'https://www.maoyan.com' },
  { label: '时光网', href: 'https://www.mtime.com' },
  { label: 'IMDb', href: 'https://www.imdb.com' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="container-page py-10 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="text-lg font-bold text-background-50">美丽小蜜桃3影视大全</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注于影视资讯展示与查询的平台，汇聚最新电影、电视剧的剧情介绍、演员阵容与上映动态，帮助你在观看前快速了解每一部作品。
            </p>
            <p className="mt-3 text-sm text-background-300">本站仅提供影视内容介绍与信息查询，不提供播放、下载等服务。</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/category/movie" className="cursor-pointer transition-colors hover:text-accent-400">
                影视分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="cursor-pointer text-background-200 transition-colors hover:text-accent-400">
                  电影大全
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="cursor-pointer text-background-200 transition-colors hover:text-accent-400">
                  电视剧大全
                </Link>
              </li>
              <li>
                <Link to="/search?q=%E6%82%AC%E7%96%91" className="cursor-pointer text-background-200 transition-colors hover:text-accent-400">
                  悬疑影视专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-background-200 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">友情链接</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {FRIEND_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="cursor-pointer text-background-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center">
          <p>© 2026 美丽小蜜桃3影视大全 · 保留所有权利</p>
          <p>内容为演示展示用途，数据仅供浏览参考</p>
        </div>
      </div>
    </footer>
  );
}